module.exports = __webpack_public_path__ + "static/media/Group 1597880740.e1c08653.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/Group 1597880740.png
// module id = 1207
// module chunks = 0